module.exports = __webpack_public_path__ + "img/icon_menu_comentarios_hover.138a280f.svg";